module.exports = __webpack_public_path__ + "static/starburst-dark-611055a94c50eb7d22dc578c2643b086.svg";